//import { createSelector } from '@reduxjs/toolkit';

// import {
//   MessageModel,
//   ConversationContentProps,
//   MainContainer,
//   ChatContainer,
//   ConversationHeader,
//   Search,
//   ConversationList,
//   Conversation,
//   Sidebar,
//   ExpansionPanel,
//   Avatar,
//   MessageList,
//   Message,
//   MessageInput,
//   MessageGroup
// } from '@chatscope/chat-ui-kit-react';

// import {

//     User,

//     Presence,
//     ChatState,          // <-- ChatState imported here
//     MessageGroup,       // <-- Internal types imported for completeness
//     GroupedMessages,
//     ChatMessage,
//     MessageContentType,
//     Sender,
//     SenderType,
//     MessageDirection,    // <-- Internal types imported for completeness
//     TypedMessageContent,
//     TextContent
// } from "@chatscope/use-chat";


import { Conversation, ConversationRole, MessageStatus, Participant } from '@chatscope/use-chat';
// NOTE: Please ensure these imports match your actual file structure
//import { chatscopeApi } from './useChatSlice';
//import { RootState } from '../app/store';

//import { RootState } from './RTKStorage';

// --- Assumed Data Structures (Matching your Firestore/API Data) ---

// Define the shape of the data returned by your RTK Query endpoint

export interface RawMessage {
    id: number;
    body: string;
    originator_id: number;
    sent_at: string; // Unix timestamp
    is_read: boolean;
    conversation_id: number,
    metadata?: any
}
export interface RawConversationMember { id: number; name_public: string }
export interface RawConversationOptionalId {
    id?: number;
    chat_name: string;
    //last_message_text: string;
    //last_message_date: number; // Unix timestamp
    members: RawConversationMember[]//{ id: number; name_public: string }[];
    is_named_chat: boolean,
    message_count?: number,
    //last_message_sender_name: string
    unread_message_count?: number,
    metadata?: any
    // We assume the full list of messages is available in the conversation object
    //messages: RawMessage[];
}

export interface RawConversation extends RawConversationOptionalId {
    id: number;
}


interface DataWithSpotlight<TMetadata> {
    metadata: TMetadata;      // reference to original metadata type
    is_named_chat: boolean;   // copied value
    readonly spotlight: any;  // getter — type can match what metadata.spotlight is
}
type DataWithSpotlightAnyMetadata = DataWithSpotlight<any>;
export const CreateConversationFromRaw: (rawMsg: RawConversation, updateUnreadCounter?: boolean) => Conversation<DataWithSpotlightAnyMetadata> = (rawConv, updateUnreadCounter) => {
    // Calculate unread count (messages sent by others that are not yet read)
    const unreadCount = rawConv.unread_message_count// for now rawConv.messages.filter(m => m.originator_id !== currentUserId && !m.is_read).length;

const data: DataWithSpotlightAnyMetadata = {
    metadata: rawConv.metadata,         // reference to original metadata, no copy
    is_named_chat: rawConv.is_named_chat, // copied value

    // getter for spotlight (reads from metadata)
    get spotlight() {
          return (this.metadata || {}).spotlight ?? false;
    }
};


    const newConvo = new Conversation({
        id: rawConv.id.toString(),
        ...updateUnreadCounter ? { unreadCounter: unreadCount } : {},
        description: rawConv.chat_name,
        //lastSenderName: rawConv.last_message_sender_name || 'Unknown', 
        //lastMessageText: rawConv.lastMessageText,
        //lastMessageDate: new Date(rawConv.lastMessageDate), // Convert timestamp to Date object
        draft: "", // Placeholder
        participants: rawConv.members.map(p => new Participant({ id: p.id.toString(), role: undefined })),
        //isGroup: rawConv.participants.length > 2,
        data
    });
    //newConvo.data.is_named_chat = rawConv.is_named_chat
    return newConvo
};